import React from 'react';

import {
  Autocomplete,
  AutocompleteProps,
  ListItem,
  ListItemText,
  TextField,
  TextFieldProps,
} from '@mui/material';

export type Option<V> = {
  label: string;
  value: V;
};

export type CustAutocompleteProps<V> = Omit<
  AutocompleteProps<Option<V>, false, boolean, false>,
  'renderInput'
>;

interface IProps<V> extends CustAutocompleteProps<V> {
  label: string;
  textFieldProps?: TextFieldProps;
}

const AutocompleteSingleOption = <V,>({
  label,
  textFieldProps,
  ...autocompleteProps
}: IProps<V>) => {
  return (
    <Autocomplete
      getOptionLabel={(option) => option.label}
      renderOption={(props, option, state) => (
        <ListItem
          sx={{
            borderBottom: (theme) =>
              state.selected
                ? `2px solid ${theme.palette.primary.main}`
                : '2px solid transparent',
          }}
          disableGutters
          disablePadding
          {...props}
        >
          <ListItemText primary={option.label} />
        </ListItem>
      )}
      disableClearable={autocompleteProps.value !== null}
      renderInput={(params) => (
        <TextField {...params} label={label} {...textFieldProps} />
      )}
      {...autocompleteProps}
    />
  );
};

export default AutocompleteSingleOption;
